import React, {FC} from 'react';

import {InfoBubble, InfoBubbleInstanceProps} from '../../../libs/shared/ui/src/components/tip/infoBubble';
import {OnboardingTipTypesEnum} from '../../models/api/preferencesModel';
import {useOnboardingInfoBubblePresenter} from './onboardingInfoBubbleHook';

/*
 * Component.
 */

export const ReadStatusInfoBubbleHighlight: FC<InfoBubbleInstanceProps> = ({anchor}) => {
  const {isVisible, closeInfoBubble: onClose} = useOnboardingInfoBubblePresenter(
    OnboardingTipTypesEnum.READ_STATUS_HIGHLIGHT,
  );

  const onRequestClose = () => {
    onClose([OnboardingTipTypesEnum.READ_STATUS_CELL, OnboardingTipTypesEnum.READ_STATUS_HIGHLIGHT]);
  };

  return (
    <InfoBubble
      anchor={anchor}
      position="top"
      isVisible={isVisible}
      isInteractive
      onRequestClose={onRequestClose}
    />
  );
};
